<script>
  import { fade } from "svelte/transition";
  import Img from "../../components/Img.svelte";
  import Alert from "../../components/Alert.svelte";
  import Navigationbar from "../../components/Navigationbar.svelte";
  import CardWraper from "../../components/CardWraper.svelte";
  import Placeholder from "../../components/placeholder/Placeholder.svelte";
  import Rating from "../../components/Rating.svelte";

  //liblary
  import axios from "axios";
  import AsideMarket from "../../components/AsideMarket.svelte";
  import { session } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  export let data;
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }
  //alert
  let alert = [];

  let items = [];

  let domain = "";
  let toko = "belanja";
  let page = "";
  let category = "";
  let q = "";
  let nav_category;
  let nav_q;
  let nav_domain;

  if (data.page) {
    page = data.page;
  } else {
    page = 1;
  }
  if (data.q) {
    q = data.q;
    nav_q = "/q/" + data.q;
  } else {
    q = "-";
    nav_q = "q/-";
  }

  if (data.domain) {
    domain = data.domain;
    nav_domain = data.domain;
  } else {
    domain = "";
    nav_domain = "";
  }
  if (data.category) {
    category = data.category;
    nav_category = "/" + data.category;
  } else {
    category = "";
    nav_category = "/";
  }

  $: listproduct = [];
  $: category_related = [];
  $: pagination = [];
  $: filter = [];
  $: shop = false;
  $: shop_rating = 0;
  $: shop_owner = [];
  $: notfound = false;
  $: if (settings) {
    session.subscribe((value) => {
      settings = value;
    });
    listProduct(page, data.category);
  }

  function listProduct(page, category = false) {
    let area = "";
    if (localStorage["area"]) {
      area = localStorage["area"];
    }
    axios
      .get(settings.url + "/warga/etalase", {
        params: {
          authorization: settings.token,
          page: page,
          domain: domain,
          category: category,
          q: q,
          area: area,
        },
      })
      .then(function (response) {
        if (response.data.data.length < 1) {
          notfound = true;
        }
        listproduct = response.data.data;
        category_related = response.data.category;
        pagination = response.data.pagination;
        filter = response.data.filter;
        shop = response.data.shop;
        shop_owner = response.data.shop_owner;
        shop_rating = response.data.shop_rating;
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }

  let next = 1;
  let pref = 0;
  $: next = Math.ceil(Math.floor(pagination.page) + 1);
  $: pref = Math.ceil(Math.floor(pagination.page) - 1);
  function listProductPref() {
    pref = Math.ceil(Math.floor(pagination.page) - 1);
    listProduct(pref, data.category);
  }
  function listProductNext() {
    next = Math.ceil(Math.floor(pagination.page) + 1);
    listProduct(next, data.category);
  }
  const removeDuplicate = function (arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  };
</script>

<svelte:head>
  <title>Belanja Ke Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
{#if shop}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Belanja di {shop.nameShop}"
    filter="true"
  />
{:else}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Belanja"
    filter="true"
  />
{/if}
<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  {#if shop}
    <div class="flex flex-wrap items-center px-3 mx-auto center">
      <div
        class="flex flex-wrap items-center justify-between w-full h-auto p-3 bg-white rounded-lg shadow-lg lg:w-3/6 lg:h-56 lg:p-10 lg:py-3 lg:my-0 lg:rounded-br-none lg:rounded-tl-full lg:relative"
      >
        <div
          class="fixed bottom-0 right-0 z-10 w-10 mb-5 mr-5 lg:z-auto md:z-auto lg:absolute lg:right-0 lg:top-0 lg:mt-20 lg:-mr-5"
        >
          {#if shop_owner}
            <a
              href="./tokoku/add"
              class="flex items-center justify-center w-10 h-10 text-xl text-center text-white bg-blue-600 rounded-full shadow-md lg:w-auto md:w-auto focus:bg-gray-500 focus:outline-none hover:bg-blue-400"
              >+</a
            >
          {/if}

          <a
            on:click|preventDefault={() =>
              document.getElementById("share").classList.toggle("hidden")}
            href="./belanja/{shop.domain}"
            class="relative flex items-center justify-center w-10 h-10 p-2 my-2 text-xs text-center text-white bg-gray-200 rounded-full shadow-md lg:w-auto md:w-auto focus:bg-gray-200 focus:outline-none hover:bg-gray-100"
            ><img alt="share" title="Bagikan" src="assets/svg/share.svg" />
            <div
              id="share"
              class="absolute bottom-0 right-0 hidden w-auto p-2 px-4 mb-12 text-gray-700 bg-white border-2 border-gray-200 rounded-lg shadow-lg"
            >
              <div class="pb-2 text-xs bg-white">Bagikan</div>
              <div class="flex w-full gap-2">
                <span
                  on:click={() =>
                    window.open(
                      "https://web.facebook.com/sharer/sharer.php?u=" +
                        encodeURIComponent(
                          "https://app.dekatan.com/#!/belanja/" + shop.domain
                        ),
                      "_blank"
                    )}
                  class="flex items-center justify-center w-12 h-12 overflow-hidden bg-gray-200 rounded-lg shadow-none focus:shadow-none lg:w-8 md:w-10 lg:h-8 md:h-10 hover:shadow-md"
                  ><img
                    alt="fb"
                    title="Bagikan ke Facebook"
                    src="assets/svg/fb.svg"
                  /></span
                >
                <span
                  on:click={() =>
                    window.open(
                      "https://twitter.com/intent/tweet?text=&url=" +
                        encodeURIComponent(
                          "https://app.dekatan.com/#!/belanja/" + shop.domain
                        ),
                      "_blank"
                    )}
                  class="flex items-center justify-center w-12 h-12 overflow-hidden bg-gray-200 rounded-lg shadow-none focus:shadow-none lg:w-8 md:w-10 lg:h-8 md:h-10 hover:shadow-md"
                  ><img
                    alt="tw"
                    title="Bagikan ke Twitter"
                    src="assets/svg/twitter.svg"
                  /></span
                >
                <span
                  on:click={() =>
                    window.open(
                      "https://api.whatsapp.com/send?text=" +
                        encodeURIComponent(
                          "https://app.dekatan.com/#!/belanja/" + shop.domain
                        ),
                      "_blank"
                    )}
                  class="flex items-center justify-center w-12 h-12 overflow-hidden bg-gray-200 rounded-lg shadow-none focus:shadow-none lg:w-8 md:w-10 lg:h-8 md:h-10 hover:shadow-md"
                  ><img
                    alt="wa"
                    title="Bagikan ke WhatsApp"
                    src="assets/svg/wa.svg"
                  /></span
                >
              </div>
            </div></a
          >
        </div>
        <div
          class="flex items-center w-full h-full text-center lg:w-full md:w-4/6"
        >
          <div
            class="w-4/12 h-auto p-2 overflow-hidden lg:w-4/12 md:w-2/6 lg:-mt-10 lg:-ml-8"
          >
            {#if shop.avatar != 0}
              <Img
                id={shop.nameShop}
                csscont="none"
                showplaceholder="false"
                datasrc="https://pics.dekatan.com/shop/{shop.avatar}"
                alt={shop.nameShop}
                css="bg-gray-300 border-4 border-white rounded-full shadow-md"
              />
            {:else}
              <img
                id={shop.nameShop}
                src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"
                alt={shop.nameShop}
                class="bg-gray-300 border-4 border-white rounded-full shadow-md"
              />
            {/if}
          </div>
          <div class="w-4/5 p-2 text-left lg:w-5/6 md:w-4/6">
            <h1>
              <a
                href="/belanja/{shop.domain}"
                class="block text-xl font-bold lg:text-3xl">{shop.nameShop}</a
              >
            </h1>

            <p class="text-sm font-light text-gray-600">{shop.description}</p>

            {#if shop_rating != 0}
              <div class="my-2 -ml-1">
                <Rating size="5" rating={shop_rating} />
              </div>
            {/if}
            <span class="text-sm font-light text-blue-600"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="inline"
                ><defs>
                  <path
                    id="a"
                    d="M12 12.209a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-.001-10.21C8.072 2 5 4.968 5 8.785c0 4.837 4.446 10.154 6.251 12.1a1.01 1.01 0 0 0 1.491-.005C14.545 18.916 19 13.62 19 8.644 19 5.159 16.16 2 11.999 2"
                  />
                </defs>
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <mask id="b" fill="#fff">
                    <use xlink:href="#a" />
                  </mask>
                  <use fill="#9FA6B0" xlink:href="#a" />
                  <g fill="#6C727C" fill-rule="nonzero" mask="url(#b)">
                    <path d="M1 1h22v22H1z" />
                  </g>
                </g></svg
              >
              {shop.location}</span
            >
          </div>
        </div>
      </div>
      <div
        class="w-full overflow-hidden text-center rounded-r-lg shadow-lg lg:w-3/6"
      >
        <div
          class="flex-row items-center justify-center hidden w-full h-56 mx-auto overflow-hidden bg-gray-300 rounded-t-lg rounded-r-lg lg:flex md:hidden"
        >
          <Img
            id={shop.nameShop}
            csscont="none"
            showplaceholder="false"
            datasrc="https://pics.dekatan.com/{shop.cover}"
            alt={shop.nameShop}
          />
        </div>
      </div>
    </div>

    <div class="py-3 mx-3">
      <nav class="flex items-center text-sm text-gray-700">
        <a class="transition hover:text-blue-700" href="/belanja">Belanja</a>
        <span class="block mx-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="12"
            viewBox="0 0 8 12"
          >
            <g fill="none" fill-rule="evenodd">
              <path d="M-4-2h16v16H-4z" />
              <path
                fill="#676767"
                fill-rule="nonzero"
                d="M6.195 6L.862 11.333l.471.472L7.138 6 1.333.195.862.667z"
              />
            </g>
          </svg>
        </span>
        <a class="transition hover:text-blue-700" href="/belanja/{shop.domain}"
          >{shop.nameShop}
        </a>
      </nav>
    </div>
  {:else if shop == null}
    <div class="py-3 mx-3">
      <nav class="flex items-center text-sm text-gray-700">
        <a class="transition hover:text-blue-700" href="/">Beranda</a>
        <span class="block mx-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="12"
            viewBox="0 0 8 12"
          >
            <g fill="none" fill-rule="evenodd">
              <path d="M-4-2h16v16H-4z" />
              <path
                fill="#676767"
                fill-rule="nonzero"
                d="M6.195 6L.862 11.333l.471.472L7.138 6 1.333.195.862.667z"
              />
            </g>
          </svg>
        </span>

        <a class="transition hover:text-blue-700" href="/belanja">Belanja</a>
      </nav>
    </div>
  {:else}
    <div
      class="flex flex-wrap items-center mx-auto bg-white rounded-lg shadow-lg center lg:my-0"
    >
      <div class="w-full text-center lg:w-4/6">
        <div
          class="flex-row items-center justify-center hidden w-full h-56 mx-auto overflow-hidden bg-gray-300 rounded-t-lg rounded-l-lg lg:flex md:hidden"
        />
      </div>
      <div
        class="flex flex-wrap items-center justify-between w-full h-auto p-3 bg-white rounded-lg shadow-lg lg:w-2/6 lg:h-56 lg:p-10 lg:my-0 lg:rounded-bl-none"
      >
        <div class="flex w-full text-center lg:w-full md:w-4/6">
          <Placeholder type="3" css="width:100%;" />
        </div>
      </div>
    </div>

    <div class="py-3 mx-3">
      <nav class="flex items-center text-sm text-gray-700">
        <a class="transition hover:text-blue-700" href="/">Beranda</a>
        <span class="block mx-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="12"
            viewBox="0 0 8 12"
          >
            <g fill="none" fill-rule="evenodd">
              <path d="M-4-2h16v16H-4z" />
              <path
                fill="#676767"
                fill-rule="nonzero"
                d="M6.195 6L.862 11.333l.471.472L7.138 6 1.333.195.862.667z"
              />
            </g>
          </svg>
        </span>

        <a class="transition hover:text-blue-700" href="/belanja">Belanja</a>
      </nav>
    </div>
  {/if}
  <div class="flex">
    <AsideMarket {category} {q} {domain} />
    <div class="w-full mx-auto">
      {#if category_related.length > 1}
        <div class="w-full overflow-x-auto rounded-lg lg:p-2">
          <div class="flex text-xs">
            {#each removeDuplicate(category_related) as l}
              {#if domain}
                <a
                  id="btnfilter-400"
                  class="flex items-center justify-center w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-lg shadow-md cursor-pointer lg:w-auto lg:h-12 btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="belanja/{domain}/c/{l.alias}"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    {l.title}
                  </div></a
                >
              {:else}
                <a
                  id="btnfilter-400"
                  class="flex items-center justify-center w-1/2 px-4 py-2 mx-1 my-1 text-gray-800 bg-white border rounded-lg shadow-md cursor-pointer lg:w-auto lg:h-12 btnfilter md:w-1/4 hover:text-green-700 hover:border-green-300"
                  href="belanja/c/{l.alias}"
                  ><div
                    class="relative flex items-center justify-between text-center"
                  >
                    {l.title}
                  </div></a
                >
              {/if}
            {/each}
          </div>
        </div>
      {/if}

      <div class="flex flex-wrap w-full p-3 md:mt-0">
        {#if pagination.page_total > 0}
          <span class="text-xs text-gray-700"
            >Menampilkan
            {pagination.total}
            Produk
            {#if filter.query.set != "false"}
              <b class="italic">"{filter.query.set}"</b>
            {/if}
            {#if filter.category.name != null}
              Dalam
              <b>{filter.category.name}</b>
            {/if}
            (<b
              >{pagination.start}
              -
              {listproduct.length + pagination.start - 1}</b
            >
            dari
            <b>{pagination.total}</b>)</span
          >
        {:else if notfound == true}
          <div class="w-full px-2 mx-auto">
            <div class="w-full p-10 bg-white rounded-lg shadow-lg">
              <div class="my-6 text-center">
                <h2 class="text-3xl">Belum nemuin produk nih..</h2>
                <p class="pb-5 text-gray-500">
                  Ini peluang untuk jadi yang pertama menjualnya, Jualan
                  Sekarang !!
                </p>
                <a
                  href="./tokoku/add"
                  class="px-4 py-2 text-xl text-white bg-blue-400 rounded-lg lg:px-24"
                  >Jualan Sekarang</a
                >
              </div>
            </div>
          </div>
        {/if}
      </div>

      {#if listproduct.length < 1}
        {#if notfound == false}
          <div
            class="flex flex-wrap w-full pb-3 mt-2 overflow-auto md:mt-0 mansory"
          >
            {#each [1, 2, 3, 4, 5] as l}
              <span class="block w-1/2 lg:w-1/5 md:w-1/3">
                <div class="p-1 md:p-2" id={l}>
                  <div
                    class="overflow-hidden bg-white rounded-lg shadow-md hover:shadow-lg"
                  >
                    <Placeholder type="1" css="height:300px;" />
                  </div>
                </div>
              </span>
            {/each}
          </div>
        {/if}
      {:else}
        <div
          class="flex flex-wrap w-full pb-3 mt-2 overflow-auto md:mt-0 mansory"
        >
          <CardWraper items={listproduct} />
        </div>
      {/if}

      <div class="flex flex-wrap justify-center w-full pb-3 mt-2 md:mt-0">
        {#if pagination.page_total > 0}
          {#if pagination.page == 1}
            {#if pagination.page_total == pagination.page}
              <div class="mt-5 separator">Hanya itu yang dapat ditampilkan</div>
            {:else}
              <a
                href="{toko}{nav_category}{nav_q}/page/{next}"
                on:click|preventDefault={listProductNext}
                class="h-8 mx-2 text-xs text-gray-600 bg-blue-100 rounded-full shadow hover:text-gray-800"
                ><span class="mx-2 text-xs">next</span>
                <span
                  class="inline-block w-8 h-8 p-2 text-center bg-white rounded-full shadow"
                  >&raquo;</span
                ></a
              >
            {/if}
          {:else if pagination.page > 1}
            {#if pagination.page_total == pagination.page}
              <a
                href="{toko}{nav_category}{nav_q}/page/{pref}"
                on:click|preventDefault={listProductPref}
                class="h-8 mx-2 text-xs text-gray-600 bg-blue-100 rounded-full shadow hover:text-gray-800"
                ><span
                  class="inline-block w-8 h-8 p-2 text-center bg-white rounded-full shadow"
                  >&laquo;</span
                ><span class="mx-2 text-xs">Pref</span></a
              >
            {:else}
              <a
                href="{toko}{nav_category}{nav_q}/page/{pref}"
                on:click|preventDefault={listProductPref}
                class="h-8 mx-2 text-xs text-gray-600 bg-blue-100 rounded-full shadow hover:text-gray-800"
                ><span
                  class="inline-block w-8 h-8 p-2 text-center bg-white rounded-full shadow"
                  >&laquo;</span
                ><span class="mx-2 text-xs">Pref</span></a
              >
              <a
                href="{toko}{nav_category}{nav_q}/page/{next}"
                on:click|preventDefault={listProductNext}
                class="h-8 mx-2 text-xs text-gray-600 bg-blue-100 rounded-full shadow hover:text-gray-800"
                ><span class="mx-2 text-xs">next</span>
                <span
                  class="inline-block w-8 h-8 p-2 text-center bg-white rounded-full shadow"
                  >&raquo;</span
                ></a
              >
            {/if}
          {/if}
        {:else}&nbsp;{/if}
      </div>
    </div>
  </div>
</main>
